import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import ConfirmAddUser from './ConfirmAddUser';

/**
 * Confirm Add User page route.
 */
const ConfirmAddUserRoute: FuseRouteItemType = {
  path: 'add-user-verify/:key',
  element: <ConfirmAddUser />,
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  auth: null
};

export default ConfirmAddUserRoute;
